import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './js/router'
import VueHead from 'vue-head'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArchway, faSitemap } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'simplelightbox'

import { SITE_ANALYTICS, SITE_TITLE } from './js/config'

import '../static/fonts/dosis/styles.css'
import '../static/fonts/ionic/css/material-design-iconic-font.css'
import '../static/fonts/proad/styles.css'
import 'simplelightbox/dist/simplelightbox.min.css'
import 'font-awesome/scss/font-awesome'

library.add(faArchway, faSitemap)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueHead)

Vue.prototype.$SITE_TITLE = SITE_TITLE

Vue.config.productionTip = false

// Rola a página para o topo sempre que há
// mudança na rota através do vue-router
router.beforeEach(function (to, from, next) {
  let rotas = ['DCF', 'DGC', 'DGI', 'DCOM', 'DSP', 'CGT', 'ASTEC']
  let isScroll = false
  rotas.forEach(rota => {
    if (to.name.includes(rota) && to.params.page >= 1) {
      document.getElementById('breadcrumb').scrollIntoView()
      isScroll = true
    }
  })
  if (!isScroll) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  next()
})

// Adiciona o código para o Google Analytics
// somente em caso de build para produção
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: SITE_ANALYTICS,
    router
  })
}

// Diretiva para efeito dropdown
Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) { warn += `Found in component '${compName}'` }

      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler)
  },

  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#site',
  router,
  // jQuery,
  template: '<App/>',
  components: { App }
})

Vue.config.devtools = process.env.NODE_ENV !== 'production'
Vue.config.performance = true



// WEBPACK FOOTER //
// ./src/main.js